module.exports = __webpack_public_path__ + "media/images/USA-groom-image3-564048f0ce068c2fb1773c1bc7b1eafe.jpg";